import React, { FC } from 'react';
import { SortableTable } from '../../molecules';
import { ValueResponseDto } from '../../../store/landscapeAPI/value/dto/response/value-response.dto';
import { Action, Label, TableRow } from '../../atoms';

interface LandscapeIndicatorValueProps {
  data: ValueResponseDto[];
  handleDelete: (id: string) => void;
  handleUpdate: (id: string) => void;
}

const LandscapeIndicatorValue: FC<LandscapeIndicatorValueProps> = ({
  data,
  handleUpdate,
  handleDelete,
}) => {
  return (
    <SortableTable
      data={data}
      columns={[
        { label: 'Creation date ', key: 'createdOnDateTimeUtc' },
        { label: 'Quantity ', key: 'qty' },
      ]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.createdOnDateTimeUtc}></Label>
          <Label content={row.qty?.toString() ?? ''}></Label>
          <Action
            type="edit"
            size="sm"
            onClick={() => handleUpdate(row.id)}
          ></Action>
          <Action
            type="delete"
            size="sm"
            onClick={() => handleDelete(row.id)}
          ></Action>
        </TableRow>
      )}
    />
  );
};

export default LandscapeIndicatorValue;
